import React, { FC } from 'react';

import clsx from 'clsx';

import StepButton from '~/modules/extension/components/AfterSignUpStepper/StepButton';

import styles from './styles.module.scss';

type Props = {
  steps: Array<{
    isChecked: boolean;
    text: string;
    Button?: FC<{ onClick?: () => void }>;
  }>;
  className?: string;
};

const AfterSignUpStepperV2: FC<Props> = ({ steps, className }) => {
  return (
    <div className={clsx(styles.steps_list, className)}>
      {steps.map((step) => (
        <StepButton
          key={step.text}
          text={`${step.text}`}
          isChecked={step.isChecked}
        />
      ))}
    </div>
  );
};

export default AfterSignUpStepperV2;
